/*
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-02-22 14:29:46
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-02-22 14:29:46
 */
const directive = {
  has: {
    inserted: hasPermission,
    update: hasPermission,
  },
}

function hasPermission (el, binding) {
  let {
    value: [$route, args],
  } = binding

  const has = Array.isArray(args) ? $route.meta.has(...args) : $route.meta.has(args)

  if (!has) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}

export default directive
